import { Col, Descriptions, Row } from "antd";
import moment from "moment";
import React from "react";
import { ICaseDecision } from "../../../caseDecisions/model/CaseDecision";
import { IGenericCodebookItem } from "../../../codebooks/model/GenericCodebookItem";
import { DateFormats } from "../../../core/common/Constants";
import { TTranslate } from "../../../core/service/locale/TranslationService";
import { ICourtCase } from "../../model/CourtCase";
import CaseDecisionSelectionGroup from "./CaseDecisionSelectionGroup";

export interface Props {
  courtCase?: ICourtCase;
  translate: TTranslate;
  showDecisions?: boolean;
  compact?: boolean;
  onSelectDecision?(value: ICaseDecision): void;
  decisions?: ICaseDecision[];
  readonly?: boolean;
  selectedDecision?: ICaseDecision;
  decisionTypes?: IGenericCodebookItem[];
}

const renderItem = (label: string, value: string, span: number = 1) => {
  return (
    <Descriptions.Item
      label={label}
      span={span}
      labelStyle={{
        color: "#08749B",
        fontWeight: 500
      }}
    >
      {value}
    </Descriptions.Item>
  );
};
const CaseLawDocumentCourtCaseDescription = ({
  courtCase,
  translate,
  onSelectDecision,
  decisions,
  showDecisions = false,
  compact = false,
  readonly = false,
  selectedDecision = decisions?.[0],
  decisionTypes
}: Props) => {
  if (!courtCase) {
    return null;
  }
  return (
    <>
      <Descriptions layout="vertical" bordered size="small">
        {renderItem(
          translate("editors.case_decisions.court_case.court_case_number"),
          courtCase.courtCaseNumber,
          2
        )}
        {courtCase.caseDescription &&
          renderItem(
            translate("editors.case_decisions.court_case.case_description"),
            courtCase.caseDescription,
            3
          )}

        {courtCase.anonymizedCaseDescription &&
          !courtCase.caseDescription &&
          renderItem(
            translate(
              "editors.case_decisions.court_case.anonymized_case_description"
            ),
            courtCase.anonymizedCaseDescription,
            3
          )}

        {courtCase.courtCaseType && courtCase.courtCaseType?.value && !compact
          ? renderItem(
              translate("editors.case_decisions.court_case.case_type"),
              courtCase.courtCaseType?.value
            )
          : null}

        {courtCase.casePhaseTypeDescription && !compact
          ? renderItem(
              translate(
                "editors.case_decisions.court_case.case_phase_type_description"
              ),
              courtCase.casePhaseTypeDescription
            )
          : null}
        {selectedDecision?.decisionDate && !compact
          ? renderItem(
              translate("editors.case_decisions.decision_date"),
              moment(selectedDecision?.decisionDate).format(DateFormats.DATE),
              2
            )
          : null}
      </Descriptions>
      {showDecisions && courtCase?.decisions?.length > 0 ? (
        <Row>
          <Col span={24}>
            <Descriptions layout="vertical" bordered size="small">
              <Descriptions.Item
                span={4}
                label="Sudske odluke"
                labelStyle={{
                  color: "#08749B",
                  fontWeight: 500
                }}
              >
                {readonly ? (
                  <>
                    {(decisions || courtCase?.decisions || []).map(
                      (decision) => (
                        <a
                          href={`/api/case-law-documents/attachments/${decision?.attachment?.id}/download`}
                        >
                          {decision?.attachment?.name}
                        </a>
                      )
                    )}
                  </>
                ) : (
                  <>
                    <CaseDecisionSelectionGroup
                      translate={translate}
                      courtCase={courtCase}
                      caseDecisions={decisions || courtCase?.decisions || []}
                      onSelectDecision={onSelectDecision}
                      decisionTypes={decisionTypes}
                      selectedCaseDecision={
                        selectedDecision
                          ? selectedDecision
                          : courtCase.decisions
                          ? courtCase.decisions[0]
                          : undefined
                      }
                    />
                    <Row style={{ paddingTop: 20 }}>
                      <Col>
                        <a
                          href={`/case-decisions/new/${courtCase.courtCaseNumber}`}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {translate(
                            "editors.court_cases.entry_form.get_more_decisions"
                          )}
                        </a>
                      </Col>
                    </Row>
                  </>
                )}
              </Descriptions.Item>
            </Descriptions>
          </Col>
        </Row>
      ) : null}
    </>
  );
};

export default CaseLawDocumentCourtCaseDescription;
